import * as React from 'react';
import LoadingIcon, { LoadingIconProps, LoadingIconType } from './LoadingIcon';

export const LoadingIconGlide = (props: LoadingIconProps) => <LoadingIcon type={LoadingIconType.Glide} {...props} />;
export default LoadingIcon;
